export const formatDateToYYYYMMDD = (input) => {
  if (!input) {
    return "";
  }

  let date;

  if (input instanceof Date) {
    date = input;
  } else if (typeof input === "string") {
    const parsed = new Date(input);
    if (isNaN(parsed)) {
      return "";
    }
    date = parsed;
  } else {
    return "";
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const formatFileSize = (bytes) => {
  const size = Number(bytes);
  if (!size || isNaN(size) || size <= 0) return "";

  const units = ["bytes", "KB", "MB", "GB", "TB"];
  const index = Math.floor(Math.log(size) / Math.log(1024));
  const value = size / Math.pow(1024, index);

  const rounded =
    value >= 10 || index === 0 ? value.toFixed(0) : value.toFixed(1);

  return `${rounded} ${units[index]}`;
};

export const formatCreatedDate = (isoString) => {
  if (!isoString) return "";

  const date = new Date(isoString);
  if (isNaN(date.getTime())) return "";

  return date.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};
